import { CheckedChecklist, Phone } from '@/components/pages/icons';
import Cta from '@/components/pages/cta';
import { CtaProps } from './type';

export function NavbarCtas({
  initialState,
  ctaHref,
  onClickCta,
  phone,
  showFreeCaseReviewButton = true,
  showTalkToSpecialistButton = true,
}: CtaProps & { initialState: boolean }) {
  return (
    <>
      {showFreeCaseReviewButton && (
        <Cta
          size="md"
          variation={!initialState ? 'outline' : 'outline-white'}
          text="Free case review"
          icon={<CheckedChecklist />}
          iconSide="left"
          href={ctaHref}
          onClick={onClickCta}
          className="group-hover:ring-brand-button group-hover:text-brand-button"
          data-cta-form
        />
      )}

      {showTalkToSpecialistButton && (
        <Cta
          size="md"
          variation="flat"
          text="Talk to a specialist"
          icon={<Phone />}
          iconSide="left"
          href={phone}
          data-cta-phone
        />
      )}
    </>
  );
}
